import Popup from "../../components/base/popup";
import Form from "../../components/base/forms/form";
import Api from "../../lib/api";

export default class WidgetMailingPopup extends Popup {
	constructor(props) {
		super(props);

		this.$root = document.querySelector('.widget-mailing-popup');

		this.cookie = costorage.get('h_mailingPopup');

		if (!this.cookie && window.matchMedia('(min-width: 769px)').matches) {
			this.init();
		}
	}

	init() {
		if (this.$root == null) {
			return;
		}

		this.initForm();
		setTimeout(() => {
			this.show();
		}, 5000);

		super.init();
	}

	initForm() {
		try {
			const form = new Form({
				formId: 'mailing-popup',
				uri: '/2.0/subscribe/blog',
				data: {
					referrer: location.href,
					city: Api.currentCityId
				},
				submitConf: {
					animation: false
				},
				subscriptions: [{
					event: 'beforeSubmit',
					callback: () => {
						this.hide();
					}
				}]
			});
		} catch (err) {
			console.error('MailingPopupForm:', err);
		}
	}

	setCookie() {
		costorage.set('h_mailingPopup', 1, {
			expires: 45 * 24 * 60 * 60,
			domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua',
			path: "/"
		});
	}

	hide() {
		super.hide();
		this.setCookie();
	}
}